import { render, staticRenderFns } from "./DealerHeader.vue?vue&type=template&id=621a3e5c&scoped=true"
import script from "./DealerHeader.vue?vue&type=script&lang=js"
export * from "./DealerHeader.vue?vue&type=script&lang=js"
import style0 from "./DealerHeader.vue?vue&type=style&index=0&id=621a3e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a3e5c",
  null
  
)

export default component.exports